import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { openDB, type IDBPDatabase } from 'idb';

const DB_NAME = 'grautomates-query-cache';
const STORE_NAME = 'queries';
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDB() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      },
    });
  }
  return dbPromise;
}

export const indexedDBPersister = createAsyncStoragePersister({
  storage: {
    async getItem(key: string) {
      const db = await getDB();
      return (await db.get(STORE_NAME, key)) ?? null;
    },
    async setItem(key: string, value: string) {
      const db = await getDB();
      await db.put(STORE_NAME, value, key);
    },
    async removeItem(key: string) {
      const db = await getDB();
      await db.delete(STORE_NAME, key);
    },
  },
  // Throttle writes to IndexedDB — don't write on every query update
  throttleTime: 1000,
});
